
import React, { useState, useEffect, useContext,useRef  } from 'react';
import { addBusinessDays } from 'date-fns';
import Select from 'react-select';
import { useNavigate, useLocation } from 'react-router-dom';
import { Audio } from 'react-loader-spinner';
import { MdOutlineCancel ,  MdRestore, MdPreview} from 'react-icons/md';
import { IoMdAdd,IoMdMore,IoMdCheckmark } from 'react-icons/io';
import { FaTrash } from "react-icons/fa";
import { FaSackDollar } from "react-icons/fa6";
import { BsFillSendFill } from "react-icons/bs";
import { TiCancel } from "react-icons/ti";
import { Layout, Header } from '../../../../components';
import { handleApi, formatCurrency, formatTwoDecimal,formatMediumDate } from '../../../../utils/utils';
import AppContext from '../../../../contexts/AppContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//import ApproveOrder from './ApproveOrder00';

const NewInvoice= () => {
  const location = useLocation();
  const { order } = location.state || {};
  const [isLoading, setIsLoading] = useState(false);
  const invoiceNoInputRef = useRef(null);
  const [showSubmitButton, setShowSubmitButton] = useState(true);
  const { userData, currentColor, actionCount, setActionCount } = useContext(AppContext);
  const navigate = useNavigate();
  const handleClose = () => { 
    navigate(-1);  // Navigate back when closing the form
  };
  // const subtotal = order?.totalUntaxedPrice || 0;
  // const discountAmount = order?.totalDiscount || 0;
  // const subtotalAfterDiscount = subtotal - discountAmount;
  // const taxAmount = order?.totalTax || 0;;
  // const grandTotal = subtotalAfterDiscount + taxAmount;

  // Format the values
  // const formattedSubtotal = formatCurrency(subtotal.toFixed(2));
  // const formattedDiscount = formatCurrency(discountAmount.toFixed(2));
  // const formattedSubtotalAfterDiscount = formatCurrency(subtotalAfterDiscount.toFixed(2));
  // const formattedTax = formatCurrency(taxAmount.toFixed(2));
  // const formattedGrandTotal = formatCurrency(grandTotal.toFixed(2));
    
    const  calculateDueDate=(startDate) =>{
        return addBusinessDays(startDate, 30).toISOString().split('T')[0];
    }
    const [invoice, setInvoice] = useState({
      date: new Date().toISOString().split('T')[0],
      due_date: calculateDueDate(new Date()), // Calculate based on today's date
      state: 'draft',
      order_id: order?.id || 0,
      invoice_no: "",
    });

  // Timeout helper for API calls
        const handleApiWithTimeout = async (url, invoice, userData, method, parameters, timeout = 5000) => {
          const controller = new AbortController();
          const timeoutId = setTimeout(() => controller.abort(), timeout);
      
          try {
            const response = await handleApi(url, invoice, userData, method, parameters, { signal: controller.signal });
            return response;
          } catch (error) {
            if (error.name === 'AbortError') {
              toast.error('Request timed out');
            } else {
              toast.error('Error: ' + error.message);
            }
            throw error;
          } finally {
            clearTimeout(timeoutId);
          }
        };
     

  
        const handleSubmit = async () => {
          if (!invoice.invoice_no) {
            toast.error(`Please enter invoice no`);
            invoiceNoInputRef.current.focus(); // Set focus on the input field
            return; // Stop the submit if invoice no is not supplied
          }
           
          const parameters = {}; // Make sure this is populated if needed
          setIsLoading(true); // Start loading
      
          try {
            const response = await handleApiWithTimeout('purchase/invoices', invoice, userData, 'POST', parameters);
            console.log("API Response:", response);  // Log the API response to see if we are getting the expected data
            if (response.status === 200) {
              // Now update the purchase order state to 'invoiced'
              const updateOrderState = { id: order.id, state: "invoiced" };
              const updateResponse = await handleApiWithTimeout('purchase/orders', updateOrderState, userData, 'PUT', {});
        
              if (updateResponse.status === 200) {
                toast.success('Invoice created successfully.');
                setShowSubmitButton(false);
              } else {toast.error('Failed to create invoice .', updateResponse.statusText);}
            } else {toast.error('Failed to create invoice.', response.statusText);}
          } catch (error) {
            console.error("API Error:", error);  // Log any error that might occur
            toast.error('Error creating  purchase invoice: ' + error.message);
          } finally {
            setIsLoading(false); // Always stop loading after request is done
            setActionCount(actionCount + 1); // Update action count
          }
        };  
  
  const TransactionLineHeader = () => {
    return (
      <div className="grid grid-cols-6 gap-4 p-2 border-b rounded-lg w-full bg-gray-50 text-gray-800 font-semibold text-xs">
        <div className="col-span-2 text-left">Product</div>
        <div className="col-span-1 text-center">Price</div>
        <div className="col-span-1 text-center">Qty</div>
        <div className="col-span-1 text-center">Disc %</div>
        <div className="col-span-1 text-right">Total</div>
      </div>
    );
  };

//   console.log('transaction lines sir',order.transactionLines)
 
  return (
    
    <Layout>
        <div className="m-4 bg-black rounded-xl shadow-2xl p-1">
          <ToastContainer position="top-center" autoClose={2000} />
          <div className="text-center py-4 border-b">
            <div className="w-full flex justify-end">
              <button
                className="text-white hover:text-gray-300 py-1 px-2 rounded transition-all duration-300"
                title="Close"
                onClick={handleClose}
              >
                <MdOutlineCancel size={24} color={currentColor}/>
              </button>
            </div>      
            <div className="mx-4 text-white">
              <Header category="Purchase" title="New Invoice" color={currentColor}/>
            </div>
          </div>        
    
          {/* Loading State */}
          {isLoading ? (
            <div className="flex flex-col items-center py-6">
              <Audio height="80" width="80" color="white" ariaLabel="loading" />
              <p className="mt-4 text-white">Processing payment...</p>
            </div>
          ) : (
            <div className="bg-white p-2 my-2 rounded-xl shadow-2xl">
              {/* all information */}
              <div className=" my-4   mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Order information */}
                <div className=" bg-gray-50 px-2 rounded-lg shadow-md text-gray-800">
                  <p className="text-lg text-center font-bold mb-2">ORDER INFO</p>
                  <div className="space-y-1">
                    <div className="flex justify-between text-sm">
                      <label className="font-medium">Order No.:</label>
                      <span className='font-bold'>{order?.reference || 'N/A'}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <label className="font-medium">Order Date:</label>
                      <span>{formatMediumDate(order?.date)}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <label className="font-medium">Order Status:</label>
                      <span
                        className={`uppercase font-bold ml-2 ${
                          order?.state === 'draft'
                          ? 'text-yellow-700'
                          : order?.state === 'approved'
                          ? 'text-blue-500'
                          : order?.state === 'cancelled'
                          ? 'text-red-500'
                          : order?.state === 'deleted'
                          ? 'text-gray-400'
                          : order?.state === 'restored'
                          ? 'text-green-700'
                          : order?.state === 'paid'
                          ? 'text-green-500'
                          : 'text-yellow-500' // Default to yellow for 'Pending' or unassigned states
                        }`}
                      >
                        {order?.state || 'Pending'}
                      </span>
                    </div>
                  </div>
                </div>

                {/* End order Info Section */}

                {/* supplier Information Section */}
                <div className="bg-gray-50 p-2 rounded-lg shadow-md text-gray-800 text-xs">
                  <p className="text-lg text-center font-bold mb-2 uppercase">Supplier info</p>
                  <div className="space-y-1">
                    <div className="flex justify-between text-sm">
                      <label className="font-medium">Supplier Name:</label>
                      <span>{order?.partners?.name || 'N/A'}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <label className="font-medium">Contact Person:</label>
                      <span>{order?.partners?.contact_person || 'N/A'}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <label className="font-medium">Phone:</label>
                      <span>{order?.partners?.phone_number || 'N/A'}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <label className="font-medium">Email:</label>
                      <span>{order?.partners?.email || 'N/A'}</span>
                    </div>
                  </div>
                </div>
                {/* end supplier  Info Section */}
                
                {/* Order detail  Section */}
                <div className="bg-gray-50 p-2 rounded-lg shadow-md text-gray-800 t">
                  {/* order info */}
                  <p className="text-lg text-center font-bold mb-2 uppercase ">Order Detail</p>
                  <div className="space-y-1">
                    {/* Transaction lines */}
                    <div className="bg-white rounded-lg shadow-md text-xs">
                      {order.transactionLines?.length > 0 ? (
                        <>
                          <TransactionLineHeader />
                          {order.transactionLines.map((line, index) => (
                            <div
                              key={index}
                              className={`grid grid-cols-6 p-1 border-b hover:bg-gray-50 ${index === order.transactionLines.length - 1 ? 'border-b' : ''}`}
                            >
                              <div className="col-span-2 text-gray-700">{line.description || ''}</div>
                              <div className="col-span-1 text-center text-gray-600">{formatTwoDecimal(line.unit_price) || ''}</div>
                              <div className="col-span-1 text-center text-gray-600">{line.quantity || ''}</div>
                              <div className="col-span-1 text-center text-gray-600">{line.discount_percentage || 0}</div>
                              <div className="col-span-1 text-right text-gray-600">{formatTwoDecimal(line.lineDiscountedPriceInclusive) || ''}</div> 
                            </div>
                          ))}
                        </>
                      ) : (
                        <p className="p-6 text-center text-gray-500">No transactions found. Please ensure the selected order has transactions.</p>
                      )}
                    </div>
                    {/* end Transation Lines*/}
                  </div>
                  <div className="mt-2 space-y-1 p-1  rounded-lg shadow-md text-xs">
                    <div className="flex justify-between text-xs">
                    <span>Subtotal:</span>
                    <span className='font-bold'>{order.totalPriceExclusive}</span>
                  </div>
                  <div className="flex justify-between text-xs">
                    <span>Discount:</span>
                    <span>{order.totalDiscountExclusive}</span>
                  </div>

                  <div className="flex justify-between text-xs">
                    <span>Subtotal After Discount::</span>
                    <span className='font-bold'>{order.totalDiscountedPriceExclusive}</span>
                  </div>

                  <div className="flex justify-between text-xs">
                    <span>Tax:</span>
                    <span>{order.totalTaxAfterDiscounted }</span>
                  </div>

                  <div className="flex justify-between text-xs">
                    <span>Grand Total:</span>
                    <span className='font-bold'>{order.totalDiscountedPriceInclusive}</span>
                  </div>
                </div>

                </div>
                {/* End order detail   Section */}
                {/* Invoice  information */}
                <div className="bg-gray-50 p-2 rounded-lg shadow-md text-gray-800">
                  <p className="text-lg text-center font-bold mb-2">INVOICE  INFO</p>
                <div>
                  <label className="px-2 block text-sm font-medium text-gray-700">Supplier Invoice #</label>
                  <input
                    ref={invoiceNoInputRef}
                    type="text"
                    value={invoice.invoice_no}
                    onChange={(e) => {
                        setInvoice({ ...invoice, invoice_no: e.target.value });
                      }}
                    className="w-full border border-gray-300 rounded-lg px-4 py-2 text-gray-700"
                  />
                </div>

                <div className="flex-1">
                  <label className="px-2 block text-sm font-medium text-gray-700">Invoice Date</label>
                  <input
                    type="date"
                    value={invoice.date}
                    onChange={(e) => {
                      const selectedDate = e.target.value;
                      const today = new Date().toISOString().split('T')[0];
                      if (selectedDate > today) {
                        toast.error('Invoice date cannot be later than today.');
                        setInvoice({ ...invoice, date: today });
                      } else {
                        setInvoice({ ...invoice, date: selectedDate });
                      }
                    }}
                    className="w-full border border-gray-300 rounded-lg px-4 py-2 text-gray-700"
                  />
                </div>
                <div className="flex-1">
                  <label className="px-2 block text-sm font-medium text-gray-700">Due Date</label>
                  <input
                    type="date"
                    value={invoice.due_date}
                    onChange={(e) => {
                      const selectedDate = e.target.value;
                      const today = new Date().toISOString().split('T')[0];
                      if (selectedDate < today) {
                        toast.error('Invoice date cannot be earlier than today.');
                        setInvoice({ ...invoice, due_date: today });
                      } else {
                        setInvoice({ ...invoice, due_date: selectedDate });
                      }
                    }}
                    className="w-full border border-gray-300 rounded-lg px-4 py-2  text-gray-700"
                  />
                </div>
                
                


                

                  
                    

                    
                </div>
                {/* End Invoice SInformation Section */}
                {/* supplier information */}
                
                
              </div>
                
                {/* end all information */}
    
             
    
             
    
              {/* Action Buttons */}
              <div className="flex justify-end space-x-4 mt-4">
              {showSubmitButton && (

                  <button
                      onClick={handleSubmit}
                      className="text-white px-3 py-2 font-bold rounded-lg flex bg-blue-500 hover:bg-blue-700 transition-all duration-300 transform hover:scale-105"
                  >
                      < BsFillSendFill size={25} />
                      <span>SUBMIT INVOICE</span>
                  </button>
              )}
                <button
                  onClick={handleClose}
                  className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
                >
                  <MdOutlineCancel size={20} />
                  <span>Close</span>
                </button>
              </div>    
          </div>
      )}
    </div>
    </Layout>
   
    
  );
};
export default NewInvoice;
